<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        لیست نامه های دریافتی
      </h4>
    </b-card-header>
    <b-card-body>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="success"
          class="mb-1 float-right"
          target="_blank"
          :href="exportExcel"
      >
        <feather-icon
            icon="FileTextIcon"
            class="mr-50"
        />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-toggle.filter-box
          variant="outline-primary"
          class="mb-1"
      >
        <feather-icon
            icon="FilterIcon"
            class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
          id="filter-box"
          class="mb-2"
      >
        <b-card class="border mb-0">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label>شماره نامه:</label>
                  <b-form-input
                      v-model="search.id"
                      placeholder="شماره نامه را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>عنوان نامه:</label>
                  <b-form-input
                      v-model="search.title"
                      placeholder="عنوان را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group>
                  <label>متن شامل:</label>
                  <b-form-input
                      v-model="search.description"
                      placeholder="بخشی از متن را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>متن پیامک شامل:</label>
                  <b-form-input
                      v-model="search.sms"
                      placeholder="بخشی از متن پیامک را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                    label=" تاریخ ایجاد"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="search.createdDate"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="permissions">
                    درجه اهمیت
                  </label>
                  <b-overlay :show="!prioritiesList.length">
                    <v-select
                        v-model="search.priorities"
                        multiple
                        dir="rtl"
                        label="title"
                        :options="prioritiesList"
                        :reduce="priority => priority.id"
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>نام کاربر ارسال کننده :</label>
                  <b-form-input
                      v-model="search.sender"
                      placeholder="نام کاربر را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="role">
                    کاربران ارسال کننده
                  </label>
                  <v-select
                      v-model="search.senderUsers"
                      dir="rtl"
                      label="name"
                      :options="receiversList"
                      :reduce="receiver => receiver.id"
                      :filterable="false"
                      @search="onSearch"
                  />
                </b-form-group>

              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">

                <b-form-group>
                  <div class="demo-inline-spacing">
                    <label for="role">
                      وضعیت مشاهده:
                    </label>
                    <b-form-radio
                        v-model="search.unseen"
                        name="some-radios"
                        value=""
                    >
                      همه
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.unseen"
                        name="some-radios"
                        value="1"
                    >
                      دیده شده
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.unseen"
                        name="some-radios"
                        value="0"
                    >
                      دیده نشده
                    </b-form-radio>
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">

                <b-form-group>
                  <div class="demo-inline-spacing">
                    <label for="role">
                      وضعیت نهایی:
                    </label>
                    <b-form-radio
                        v-model="search.isClosed"
                        name="some-radios"
                        value=""
                    >
                      همه
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.isClosed"
                        name="some-radios"
                        value="1"
                    >
                      بسته شده
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.isClosed"
                        name="some-radios"
                        value="0"
                    >
                      بسته نشده
                    </b-form-radio>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-form-checkbox
                    v-model="search.replied"
                    checked="false"
                    name="check-button"
                    class="custom-control-success"
                    switch
                    inline
                >
                  فقط نامه های دارای پاسخ
                </b-form-checkbox>
              </b-col>
              <b-col md="3">
                <b-form-checkbox
                    v-model="search.forwarded"
                    checked="false"
                    name="check-button"
                    switch
                    inline
                >
                  فقط نامه های دارای باز ارسال
                </b-form-checkbox>
              </b-col>
              <b-col md="3">
                <b-form-checkbox
                    v-model="search.all_data"
                    checked="false"
                    name="check-button"
                    switch
                    inline
                >
                  جستجو در تمام نامه های من
                </b-form-checkbox>
              </b-col>
              <b-col md="3">
                <b-form-checkbox
                    v-model="search.isFavorite"
                    checked="false"
                    name="check-button"
                    switch
                    inline
                >
                  فقط نشان شده ها
                </b-form-checkbox>
              </b-col>
            </b-row>
            <hr>
            <div class="demo-inline-spacing">
              <b-button
                  type="submit"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  @click="advanceSearch"
              >
                اعمال جستجو
              </b-button>
              <b-button
                  type="button"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-secondary"
                  @click="clearSearch"
              >
                حذف فیلترها
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-collapse>
      <b-overlay :show="onProgress">
        <div ref="resultTable">

          <b-table
              :fields="fields"
              :items="items"
              hover
              striped
              responsive
              show-empty
              empty-text="رکوردی یافت نشد"
          >
            <template #cell(id)="data">
              <strong>{{ data.value }}</strong>
              <feather-icon
                  icon="BookmarkIcon"
                  size="17"
                  :class="{ 'text-warning fill-current': data.item.isFavorite }"
                  @click.stop="toggleFavorite(data.item.id)"
              />
              <b-avatar
                  v-show="!data.item.is_seen"
                  :id="`seen-row-${data.item.id}`"
                  v-b-tooltip.hover
                  title="جدید"
                  size="32"
                  variant="light-success"
              >
                <feather-icon
                    icon="MailIcon"
                />
              </b-avatar>
              <b-badge
                  v-if="data.item.isClosed"
                  variant="light-danger"
                  class="mr-1"
              >
                بسته شده
              </b-badge>
            </template>
            <template #cell(priority)="data">
              <b-badge
                  :variant="data.value.label"
                  class="mr-1"
              >
                {{ data.value.title }}
              </b-badge>
            </template>
            <template #cell(title)="data">
              <b-avatar
                  v-show="data.item.has_answered"
                  v-b-tooltip.hover
                  title="پاسخ داده شده"
                  size="32"
                  variant="light-primary"
              >
                <feather-icon
                    icon="MessageSquareIcon"
                    size="20"
                />
              </b-avatar>
              <b-avatar
                  v-show="data.item.type.key !== 'SENT'"
                  :id="`invoice-row-${data.item.id}`"
                  v-b-tooltip.hover
                  :title="data.item.type.title"
                  size="32"
                  variant="light-primary"
              >
                <feather-icon
                    :icon="data.item.type.icon"
                />
              </b-avatar>
              {{ data.value }}

              <feather-icon
                  v-show="data.item.attachmentCount"
                  :id="`invoice-row-${data.item.id}`"
                  icon="PaperclipIcon"
              />
            </template>
            <template #cell(creator)="data">
              <bdi>{{ data.value.name }}</bdi>

              <b-badge
                  v-if="search.all_data && search.all_data.toString() === 'true'"
                  :variant="data.item.userType === 'creator' ? 'light-success' :'light-primary'"
                  class="ml-1"
              >
                {{ userType(data.item.userType) }}
              </b-badge>
            </template>

            <template #cell(updatedDate)="data">
              <bdi>{{ data.value }}</bdi>
            </template>

            <template #cell(action)="data">
              <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  :to="{name: 'Tickets_Detail', params:{id: data.item.id},query:{type:'inbox'}}"
              >
                <feather-icon
                    icon="FileTextIcon"
                    class="mr-50"
                />
                <span class="align-middle">مشاهده</span>
              </b-button>
              <b-button

                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-secondary"
                  @click="archive(data.item.id)"
              >
                <feather-icon
                    icon="ArchiveIcon"
                    class="mr-50"
                />
                <span class="align-middle">آرشیو</span>
              </b-button>

            </template>

          </b-table>
          <b-pagination
              v-model="currentPage"
              class="mt-2"
              :total-rows="totalRows"
              :per-page="perPage"
          />
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BOverlay,
  BPagination,
  BBadge, BAvatar, BButton,
  VBTooltip, BCollapse, BFormInput, BFormRadio, BRow, BCol, BFormGroup, VBToggle, BFormCheckbox, BForm
} from 'bootstrap-vue'

import ripple from 'vue-ripple-directive'
import VSelect from 'vue-select'
import {doubleRaf, queryString} from '@/libs/utils'
import {debounce} from '@/libs/debounce'

export default {
  name: 'SaleGroupList',
  components: {
    BFormGroup,
    BCol,
    BRow,
    BFormRadio,
    BFormInput,
    VSelect,
    BCollapse,
    BButton,
    BAvatar,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BOverlay,
    BPagination,
    BBadge,
    BFormCheckbox,
    BForm
  },
  directives: {
    'b-tooltip': VBTooltip,
    ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'شماره نامه',
        },
        {
          key: 'title',
          label: 'عنوان',
        },
        {
          key: 'priority',
          label: 'درجه اهمیت',
        },
        {
          key: 'creator',
          label: 'سازنده',
        },
        {
          key: 'updatedDate',
          label: 'آخرین بروزرسانی',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      onProgress: false,
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      search: {},
      receiversList: [],
      getReceivers: false,
      onExportProgress: false,
      prioritiesList: [],
    }
  },
  computed: {
    exportExcel() {
      const query = queryString(this.search)
      return `${process.env.VUE_APP_API}tickets?export-excel=1&${query}`
    },
  },
  methods: {
    // rowClass(item, type) {
    //   const colorClass = 'table-success'
    //   if (!item || type !== 'row') { return }
    //
    //   // eslint-disable-next-line consistent-return
    //   if (item.is_seen === 0) { return colorClass }
    // },
    userType(type) {
      return type === 'creator' ? 'ارسال کننده' : 'دریافت کننده'
    },
    async getTicketsList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.onProgress = true
      this.$http.get('tickets', {
        params: {
          ...currentQuery,
          ...this.search,
          page: this.currentPage,
        },
      })
          .then(({data}) => {
            if (data.status) {
              this.items = data.tickets
              this.currentPage = data.meta.current_page
              this.totalRows = data.meta.total
              this.perPage = data.meta.per_page
            } else {
              this.$bvToast.toast(data.message ?? 'لیست نامه ها دریافت نشد', {
                title: 'خطای دریافت اطلاعات',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
    deleteTicket(id) {
      this.$swal({
        title: 'حذف نامه ',
        text: 'آیا از حذف نامه مطمئن هستید؟',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'لغو حذف',
        confirmButtonText: 'حذف نامه',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-success',
        },
      })
          .then(async result => {
            if (result.value) {
              this.$swal({
                title: 'در حال انجام',
                text: 'لطفا تا دریافت نتیجه منتظر بمانید',
                icon: 'info',
                confirmButtonText: 'متوجه شدم',
              })
              await this.$http.delete(`tickets/delete/${id}`)
                  .then(({data}) => {
                    if (data.status) {
                      this.$swal({
                        title: 'حذف شد',
                        text: 'حذف نامه  با موفقیت انجام شد',
                        icon: 'success',
                        confirmButtonText: 'متوجه شدم',
                        timer: 2000,
                      })
                      this.items = []
                      this.getTicketsList()
                    } else {
                      this.$bvToast.toast(data.message ?? 'حذف نامه  با خطا مواجه شد', {
                        title: 'خطای دریافت اطلاعات',
                        toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                        variant: 'danger',
                      })
                    }
                  })
                  .catch(error => {
                    this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
                      title: 'خطا در دریافت اطلاعات',
                      toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                      variant: 'danger',
                    })
                  })
            }
          })
    },
    getRelatedUsers(q) {
      this.$http.get(`tickets/related-users?name=${q}`)
          .then(({data}) => {
            if (data.status) {
              this.receiversList = data.users
              this.getReceivers = true
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست دریافت کنندگان با خطا مواجه شد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    getPriorities() {
      this.$http.get('tickets/priorities')
          .then(({data}) => {
            if (data.status) {
              this.prioritiesList = data.priorities
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست اولویت ها با خطا مواجه شد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    advanceSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.search,
        },
      })
          .then(() => {
            this.getTicketsList()
          })
          .catch(() => {
          })

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({behavior: 'smooth'})
      })
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
          .then(() => {
            this.getTicketsList()
          })
          .catch(() => {
          })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({behavior: 'smooth'})
      })
    },
    setSearchData() {
      doubleRaf(() => {
        this.search = JSON.parse(JSON.stringify(this.$route.query))
      })
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.searchUser(loading, search, this)
      }
    },
    searchUser: debounce((loading, search, vm) => {
      vm.getRelatedUsers(search)
      loading(false)
    }, 400),
    createFieldLabel(value) {
      const index = this.fields.findIndex(item => item.key === 'creator')
      if (value.toString() === 'true') {
        this.fields[index].label = 'دریافت کننده/سازنده'
      } else {
        this.fields[index].label = 'سازنده'
      }
    },
    toggleFavorite(id) {

      this.$http.post(`tickets/${id}/favorite`)
          .then(({data}) => {
            if (data.status) {
              this.items = this.items.map((ticket) => {
                if (ticket.id === id) {
                  return {
                    ...ticket,
                    isFavorite: data.ticket.isFavorite
                  }
                } else {
                  return ticket
                }
              })


            } else {
              this.$bvToast.toast(data.message, {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    archive(id) {
      this.$http.post(`tickets/${id}/archive`, {type: 'inbox'})
          .then(({data}) => {
            if (data.status) {
              this.$bvToast.toast('نامه با موفقیت آرشیو شد', {
                title: 'انجام درخواست',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'success',
              })
              const index = this.items.findIndex(item => item.id === id)

              this.items.splice(index, 1)

            } else {
              this.$bvToast.toast(data.message, {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },

  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: 'Tickets_Inbox',
          query: {page: this.currentPage},
        })
        this.items = []
        this.getTicketsList()
      }
    },
    'search.all_data': function (newValue) {
      this.createFieldLabel(newValue)
    },
  },
  mounted() {
    this.getTicketsList()
    this.getPriorities()
    this.setSearchData()
  },
}
</script>

<style>

</style>
